import * as Yup from "yup";

export const shippingSchema = Yup.object({
    businessname: Yup.string("Please enter your Businessname.").required("Required."),
    address: Yup.string("Please enter your Address.").required("Required."),
    address02: Yup.string("Please enter your Address.").required("Required."),
    city: Yup.string("Please enter your City.").required("Required."),
    state: Yup.string("Please enter your State.").required("Required."),
    zipcode: Yup.number("Please enter your Zipcode.").typeError('Must be a number.').required("Required."),
    country: Yup.string("Please enter your Country.").required("Required."),
});

export const stepOneSchema = Yup.object({
    name: Yup.string()
        .trim()
        .matches(/^[A-Za-z\s]+$/, 'Name must contain only letters.')
        .required('Name is required.'),
    lastname: Yup.string()
        .trim()
        .matches(/^[A-Za-z\s]+$/, 'Name must contain only letters.')
        .required('Last name is required.'),
    businessname: Yup.string()
        .trim()
        .required("Business name is required."),
    location: Yup.number("Please enter Number of location.")
        .typeError('Must be a number.')
        .required("Number of location Required.")
})

export const stepThreeSchema = Yup.object({
    number: Yup.number().required("Please enter your Mobile Number.")
})

export const stepFiveSchema = Yup.object({
    email: Yup.string().email("Please enter a valid email address.").required("Email is required."),
    number: Yup.string()
        .matches(/^(\+1|1)?\s?\(?[2-9][0-8][0-9]\)?[-.\s]?[2-9][0-9]{2}[-.\s]?[0-9]{4}$/, 'Phone number should be in US standard format.')
        .required('Phone number is required.'),
    prefired: Yup.string().required("Please choose your communication preference.")

})

export const stepFourSchema = Yup.object({
    number: Yup.number().required("Please enter your Valid Number.")
})

export const SoleTypeSchema = Yup.object({
    first_name: Yup.string().required("Please enter you Name."),
    last_name: Yup.string().required("Please enter you Name."),
    phone: Yup.string()
        .matches(/^(\+1|1)?\s?\(?[2-9][0-8][0-9]\)?[-.\s]?[2-9][0-9]{2}[-.\s]?[0-9]{4}$/, 'Phone number should be in US standard format.')
        .required('Please enter you Phone number.'),
    dob: Yup.date()
        .max(new Date(Date.now() - 13 * 365 * 24 * 60 * 60 * 1000), 'You must be at least 13 years of age.')
        .typeError('You must be at least 13 years of age.')
        .required("Please enter your Date Of Birth."),
    ssn_last_4: Yup.number()
        .typeError('Must be a number.')
        .required("Please enter your SSN Number."),
})

export const CorporationTypeSchema = Yup.object({
    name: Yup.string().required("Please enter you Name."),
    phone: Yup.string()
        .matches(/^(\+1|1)?\s?\(?[2-9][0-8][0-9]\)?[-.\s]?[2-9][0-9]{2}[-.\s]?[0-9]{4}$/, 'Phone number should be in US standard format.')
        .required('Phone number is required.'),
        registration_number: Yup.number()
        .typeError('Must be a number.')
        .required("Please enter your EIN Number."),
})

export const SoleTypeSchemaFormTwo = Yup.object({
    line1: Yup.string("Please enter you Address.").required("Required."),
    city: Yup.string("Please enter you City.").required("Required."),
    state: Yup.string("Please enter you State.")
        .matches(/^(?:Alabama|AL|Alaska|AK|Arizona|AZ|Arkansas|AR|California|CA|Colorado|CO|Connecticut|CT|Delaware|DE|Florida|FL|Georgia|GA|Hawaii|HI|Idaho|ID|Illinois|IL|Indiana|IN|Iowa|IA|Kansas|KS|Kentucky|KY|Louisiana|LA|Maine|ME|Maryland|MD|Massachusetts|MA|Michigan|MI|Minnesota|MN|Mississippi|MS|Missouri|MO|Montana|MT|Nebraska|NE|Nevada|NV|New Hampshire|NH|New Jersey|NJ|New Mexico|NM|New York|NY|North Carolina|NC|North Dakota|ND|Ohio|OH|Oklahoma|OK|Oregon|OR|Pennsylvania|PA|Rhode Island|RI|South Carolina|SC|South Dakota|SD|Tennessee|TN|Texas|TX|Utah|UT|Vermont|VT|Virginia|VA|Washington|WA|West Virginia|WV|Wisconsin|WI|Wyoming|WY)$/i, 'Invalid US state or province.')
        .required("Required."),
    postal_code: Yup.string("Please enter your Zipcode.")
        .matches(/^[0-9]{5}(?:-[0-9]{4})?$/, 'Please enter a valid US postal code.')
        .required("Required."),
    country: Yup.string("Please enter you Country.").required("Required."),
})

export const SoleTypeSchemaFormThree = Yup.object({
    bankname: Yup.string().required("Please enter you Bank Name."),
    routingnumber: Yup.number().required("Please enter you Routing Number."),
    accountnumber: Yup.number().required("Please enter you Account Number."),
})

export const ProPlanSchema = Yup.object({
    proessentail: Yup.string().required("Required.")
})

export const EditDataSchema = Yup.object({
    editplan: Yup.string().required("Required."),
    editkiosk: Yup.string().required("Required.")
})

export const WishlistDataSchema = Yup.object({
    editplan: Yup.string().required("Required."),
    editkiosk: Yup.string().required("Required.")
})

export const wishlistFormSchema = Yup.object({
    email: Yup.string().email("Please enter a valid email address.").required("Email is required."),
    number: Yup.string()
        .matches(/^(\+1|1)?\s?\(?[2-9][0-8][0-9]\)?[-.\s]?[2-9][0-9]{2}[-.\s]?[0-9]{4}$/, 'Phone number should be in US standard format.')
        .required('Phone number is required.'),
    prefired: Yup.string().required("Please choose your communication preference."),
})

export const termconditionSchema = Yup.object({
    signature: Yup.string().required("Signature is required."),
    date: Yup.date()
        .min(new Date(), 'Please select a date on or after today.')
        .typeError('Please select a date on or after today.')
        .required("Date is required.")
})

export const BankInfoSchema = Yup.object({
    bankname: Yup.string().required("Required"),
    routingnumber: Yup.number().required("Required."),
    accountnumber: Yup.number().required("Required."),
})